module.exports = __webpack_public_path__ + "img/1003.81cd9a4b.gif";